<template>
    <div v-if="loaded" class="nevs-content">
        <div class="nevs-content-top-buttons">
            <NevsButton class="success" @click="saveClick()"><i class="fa-solid fa-floppy-disk"></i>
                {{ $LANG.Get('buttons.save') }}
            </NevsButton>&nbsp;
            <NevsButton class="error" @click="backClick"><i class="fa-solid fa-arrow-left"></i> {{
                    $LANG.Get('buttons.back')
                }}
            </NevsButton>
        </div>
        <NevsCard class="form form-float">
            <NevsDateField v-model="timeOfIssue.date" :error="timeOfIssueValidation.date"
                           :label="$LANG.Get('fields.dateOfIssue')"></NevsDateField>
            <NevsMaskedField v-model="timeOfIssue.time" :error="timeOfIssueValidation.time"
                             :label="$LANG.Get('fields.timeOfIssue')"
                             :mask="'NN:NN:NN'"></NevsMaskedField>
        </NevsCard>
        <NevsCard class="form form-float">
            <NevsSelect v-if="sequences.length > 1"
                        v-model="writeOffNote.write_off_note_sequence_id"
                        :error="writeOffNoteValidation.write_off_note_sequence_id" :label="$LANG.Get('fields.sequence')"
                        :options="sequences"></NevsSelect>
            <NevsSelect v-model="writeOffNote.locale"
                        :error="writeOffNoteValidation.locale" :label="$LANG.Get('fields.language')"
                        :ajax="'select/languages'"></NevsSelect>
        </NevsCard>
        <NevsCard class="form form-float form-reason">
            <NevsTextArea v-model="writeOffNote.reason" :error="writeOffNoteValidation.reason"
                          :label="$LANG.Get('fields.writeOffReason')"></NevsTextArea>
        </NevsCard>
        <NevsCard class="items-card">
            <NevsSelect v-model="selectedWare" :ajax="'select/wares'" :error="writeOffNoteValidation.items"
                        :label="$LANG.Get('labels.selectItem')" class="item-select"></NevsSelect>
            <div class="items-container">
                <table v-show="writeOffNote.items.length !== 0" class="items-table">
                    <thead>
                    <tr class="items-table-header">
                        <td v-for="(header, key) in headers" :key="key" :style="{'width': header.width}">{{
                                header.text
                            }}
                        </td>
                    </tr>
                    </thead>
                    <tbody>
                    <tr v-for="(item, key) in writeOffNote.items" :key="key">
                        <td class="items-table-buttons">
                            <NevsButton @click="removeItemClick(key)"><i class="fa-solid fa-trash"></i></NevsButton>
                        </td>
                        <td>
                            <NevsTextField v-model="item.description" :readonly="true"></NevsTextField>
                        </td>
                        <td>
                            <NevsSelect v-model="item.measurement_unit_id" :readonly="true"
                                        :ajax="'select/measurement-units'"></NevsSelect>
                        </td>
                        <td>
                            <NevsNumberField v-model="item.supply_quantity" :decimal-places="3" :readonly="true"
                                             :thousand-separator="''"></NevsNumberField>
                        </td>
                        <td>
                            <NevsNumberField v-model="item.quantity" :decimal-places="3"
                                             :thousand-separator="''"></NevsNumberField>
                        </td>
                    </tr>
                    </tbody>
                </table>
                <div class="nevs-clear-float"></div>
            </div>
            <div class="disclaimer">{{ $LANG.Get('texts.writeOffNoteFifo') }}</div>
        </NevsCard>
    </div>
</template>

<script>
import WriteOffNote from '@/models/WriteOffNote.js';
import NevsCard from "@/components/nevs/NevsCard.vue";
import NevsButton from "@/components/nevs/NevsButton.vue";
import NevsSelect from "@/components/nevs/NevsSelect.vue";
import NevsDateField from "@/components/nevs/NevsDateField.vue";
import NevsMaskedField from "@/components/nevs/NevsMaskedField.vue";
import NevsTextField from "@/components/nevs/NevsTextField.vue";
import NevsTextArea from "@/components/nevs/NevsTextArea.vue";
import NevsNumberField from "@/components/nevs/NevsNumberField.vue";
import moment from "moment";

export default {
    name: "EntityWriteOffNote",
    components: {
        NevsNumberField, NevsTextArea, NevsTextField, NevsMaskedField, NevsDateField, NevsSelect, NevsButton, NevsCard
    },
    data() {
        return {
            loaded: false,
            writeOffNote: new WriteOffNote({}),
            writeOffNoteValidation: new WriteOffNote({}, true),
            selectedWare: null,
            timeOfIssue: {
                date: null,
                time: null
            },
            timeOfIssueValidation: {
                date: '',
                time: ''
            },
            sequences: []
        }
    },
    computed: {
        headers() {
            return [
                {
                    text: '',
                    width: '50px'
                },
                {
                    text: this.$LANG.Get('fields.description')
                },
                {
                    text: this.$LANG.Get('fields.measurementUnit'),
                    width: '100px'
                },
                {
                    text: this.$LANG.Get('labels.inStock'),
                    width: '100px'
                },
                {
                    text: this.$LANG.Get('fields.quantity'),
                    width: '100px'
                }
            ];
        }
    },
    watch: {
        'selectedWare': function () {
            if (this.selectedWare != null) {
                this.addItem();
            }
        },
        'timeOfIssue': {
            handler: function () {
                this.writeOffNote.time_of_issue = this.timeOfIssue.date + ' ' + this.timeOfIssue.time;
            },
            deep: true
        }
    },
    methods: {
        backClick() {
            if (window.history.length === 1) {
                window.close();
            } else {
                this.$router.back();
            }
        },
        saveClick() {
            let success = true;

            if ((this.writeOffNote.time_of_issue == null) || (!this.$HELPERS.DateTimePattern().test(this.writeOffNote.time_of_issue))) {
                success = false;
                this.timeOfIssueValidation.time = this.$LANG.Get('labels.timeOfIssueMissing');
            } else {
                this.timeOfIssueValidation.time = '';
            }

            if (this.writeOffNote.write_off_note_sequence_id == null) {
                success = false;
                this.writeOffNoteValidation.write_off_note_sequence_id = this.$LANG.Get('labels.sequenceMissing');
            } else {
                this.writeOffNoteValidation.write_off_note_sequence_id = '';
            }

            // Lines of the same ware draw on the same stock, so they are checked against it together.
            let itemsValidation = [];
            let requested = {};
            let termQuantity = false;
            for (let item of this.writeOffNote.items) {
                if (!(item.quantity > 0)) termQuantity = true;
                requested[item.ware_id] = (requested[item.ware_id] || 0) + Number(item.quantity);
            }
            let missing = [];
            for (let item of this.writeOffNote.items) {
                if (requested[item.ware_id] > item.supply_quantity && !missing.includes(item.description)) {
                    missing.push(item.description);
                }
            }
            if (this.writeOffNote.items.length === 0) itemsValidation.push(this.$LANG.Get('labels.noItems'));
            if (termQuantity) itemsValidation.push(this.$LANG.Get('labels.nonPositiveQuantity'));
            if (missing.length > 0) itemsValidation.push(this.$LANG.Get('labels.notEnoughInStock') + ' ' + missing.join(', '));
            if (itemsValidation.length > 0) success = false;
            this.writeOffNoteValidation.items = itemsValidation.join('\n');

            if (!success) return;

            let vm = this;
            this.$API.APICall('post', 'write-off-notes', JSON.parse(JSON.stringify(this.writeOffNote)), (data, success) => {
                if (success) {
                    vm.$CROSS_TAB_BUS.TriggerEvent('reload-write-off-notes', {});
                    vm.$LOCAL_BUS.TriggerEvent('notification', {text: vm.$LANG.Get('alerts.recordSaved')});
                    vm.backClick();
                } else if (data.error === 'invalid sequence later') {
                    vm.$LOCAL_BUS.TriggerEvent('popup', {
                        text: vm.$LANG.Get('alerts.writeOffNoteSequenceLater'),
                        type: 'alert'
                    });
                } else {
                    let unavailableWares = [];
                    for (let error of (data.errors || [])) {
                        let errorData = error.split('|$|');
                        if (errorData[0] === 'unavailable_supply' && errorData.length > 1) {
                            unavailableWares.push(errorData[1]);
                        }
                    }
                    if (unavailableWares.length === 0) {
                        vm.$HELPERS.HandleServerError(vm, data);
                    } else {
                        vm.$LOCAL_BUS.TriggerEvent('popup', {
                            text: vm.$LANG.Get('alerts.writeOffNoteMissingSupply') + unavailableWares.join('<br />'),
                            type: 'alert'
                        });
                    }
                }
            });
        },
        addItem() {
            if (this.selectedWare === null) return;
            let vm = this;
            this.$API.APICall('get', 'wares/' + this.selectedWare, {}, (data, success) => {
                if (success) {
                    vm.writeOffNote.items.push({
                        description: data.ware.name,
                        measurement_unit_id: data.ware.measurement_unit_id,
                        supply_quantity: data.supply_quantity,
                        quantity: 1,
                        ware_id: data.ware.id
                    });
                    vm.selectedWare = null;
                } else {
                    vm.$HELPERS.HandleServerError(vm, data);
                }
            }, false);
        },
        removeItemClick(index) {
            let vm = this;
            this.$LOCAL_BUS.TriggerEvent('popup', {
                type: 'confirm', text: this.$LANG.Get('alerts.generalRemovalQuestion'), callback: (response) => {
                    if (response) {
                        vm.writeOffNote.items.splice(index, 1);
                    }
                }
            });
        }
    },
    mounted() {
        this.$store.commit('selectMenu', 'catalog');
        this.$store.commit('selectSubMenu', 'writeOffNotes');

        this.sequences = this.$store.state.user.write_off_note_sequences;
        if (this.sequences.length > 0) {
            this.writeOffNote.write_off_note_sequence_id = this.$store.state.user.default_write_off_note_sequence_id
                || this.sequences[0].value;
        } else {
            this.$LOCAL_BUS.TriggerEvent('popup', {text: this.$LANG.Get('alerts.unauthorized'), type: 'alert'});
            this.$router.push('/');
            return;
        }

        this.$store.commit('setBreadcrumbs', [
            {
                label: this.$LANG.Get('modules.catalog'),
                link: null
            },
            {
                label: this.$LANG.Get('modules.writeOffNotes'),
                link: '/write-off-notes'
            },
            {
                label: this.$LANG.Get('modules.newWriteOffNote'),
                link: null
            }
        ]);

        let now = moment();
        this.timeOfIssue.date = now.format('YYYY-MM-DD');
        this.timeOfIssue.time = now.format('HH:mm:ss');
        this.writeOffNote.locale = this.$store.state.locale;

        this.$nextTick(() => {
            this.loaded = true;
        });
    }
}
</script>

<style scoped>
.form-float {
    width: 300px;
    float: left;
    margin-right: 10px;
    margin-bottom: 10px;
    padding: 15px;
}

.form-reason {
    width: 500px;
}

.items-card {
    clear: both;
}

.items-container {
    overflow-x: auto;
    white-space: nowrap;
}

.item-select {
    max-width: 500px;
}

.items-table {
    width: 100%;
    min-width: 800px;
}

.items-table-header td {
    font-size: 12px;
    padding-left: 5px;
}

.items-table td {
    vertical-align: top;
}

.items-table-buttons {
    text-align: center;
}

/* Match the button box to the field input (same 13px vertical padding) and offset it by the
   field wrapper's 5px top padding, so the buttons line up with the first row of inputs. */
.items-table-buttons .nevs-button {
    padding: 13px;
    margin-top: 5px;
}

.disclaimer {
    font-size: 12px;
    color: #5e6278;
    margin: 5px;
}
</style>
